import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const UrlListarParalelos = ApiUrl + "paralelos?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarCreditos = ApiUrl + "creditos-extra?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarCreditosEstudiantePeriodo = ApiUrl + "creditosext-estudiante-periodo?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlInsertarCredito = ApiUrl + "estudiante-creditos-extra?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlActualizarCredito = ApiUrl + "estudiante-creditos-extra";
const UrlListarEstudiantes = ApiUrl + "estudiantes?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarPeriodos = ApiUrl + "listarperiodosactivos?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"

// === CONFIGURACIONES ===
const itemsPerPage = 5;

export default class GestionEstudianteCreditosExtra extends Component {
    state = {
        estudiantes: [],
        currentItems: [],
        offset: 0,
        perPage: 5,
        pageCount: 0,
        estudianteSeleccionado: null,
        periodoSeleccionado: "",
        periodos: [],
        creditos: [],
        paralelos: [],
        creditosExtra: [],
        modal: false,
        busqueda: "",
        estudiantesFiltrados: [],
        form: {
            id: "",
            credito_extra_id: "",
            id_paralelo: "",
            parcial1: 0,
            parcial2: 0,
            parcial3: 0,
            examen_final: 0,
            examen_suspension: 0,
            equivalencia: 0,
            asistencia: 0
        }
    };

    componentDidMount() {
        this.obtenerEstudiantes();
        this.obtenerPeriodos();
        this.obtenerCreditos();
        this.obtenerParalelos();
    }

    obtenerEstudiantes = () => {
        axios.get(UrlListarEstudiantes).then(res => {
            const estudiantes = res.data.data;
            const slice = estudiantes.slice(this.state.offset, this.state.offset + this.state.perPage);
            this.setState({
                estudiantes,
                estudiantesFiltrados: estudiantes, // copia para buscar
                pageCount: Math.ceil(estudiantes.length / this.state.perPage),
                currentItems: estudiantes.slice(0, this.state.perPage)
            });
        });
    };

    filtrarEstudiantes = (e) => {
        const texto = e.target.value.toLowerCase();
        const estudiantesFiltrados = this.state.estudiantes.filter(est =>
            est.numero_identificacion_estudiante.toLowerCase().includes(texto) ||
            est.primer_nombre_estudiante.toLowerCase().includes(texto) ||
            est.segundo_nombre_estudiante.toLowerCase().includes(texto) ||
            est.primer_apellido_estudiante.toLowerCase().includes(texto) ||
            est.segundo_apellido_estudiante.toLowerCase().includes(texto)
        );

        const currentItems = estudiantesFiltrados.slice(0, this.state.perPage);

        this.setState({
            busqueda: texto,
            estudiantesFiltrados,
            currentItems,
            pageCount: Math.ceil(estudiantesFiltrados.length / this.state.perPage),
            offset: 0
        });
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        const slice = this.state.estudiantesFiltrados.slice(offset, offset + this.state.perPage);
        this.setState({ currentItems: slice, offset });
    };

    obtenerPeriodos = () => {
        axios.get(UrlListarPeriodos).then(res => {
            this.setState({ periodos: res.data.data || [] });
        });
    };

    obtenerCreditos = () => {
        axios.get(UrlListarCreditos).then(res => {
            this.setState({ creditos: res.data || [] });
        });
    };

    obtenerParalelos = () => {
        axios.get(UrlListarParalelos).then(res => {
            this.setState({ paralelos: res.data || [] });
        });
    };

    seleccionarEstudiante = (id) => {
        this.setState({
            estudianteSeleccionado: parseInt(id, 10),
            creditosExtra: [],
            periodoSeleccionado: ""
        });
    };

    seleccionarPeriodo = (e) => {
        const periodoSeleccionado = e.target.value;
        this.setState({ periodoSeleccionado }, () => {
            if (this.state.estudianteSeleccionado) {
                this.obtenerCreditosEstudiante();
            }
        });
    };

    obtenerCreditosEstudiante = () => {
        const { estudianteSeleccionado, periodoSeleccionado } = this.state;
        axios.get(`${UrlListarCreditosEstudiantePeriodo}&id_estudiante=${estudianteSeleccionado}&id_periodo_academico=${periodoSeleccionado}`)
            .then(res => {
                this.setState({ creditosExtra: res.data });
            });
    };

    mostrarModal = (credito = null) => {
        if (credito) {
            const p1 = Number(credito.parcial1) || 0;
            const p2 = Number(credito.parcial2) || 0;
            const p3 = Number(credito.parcial3) || 0;
            const ef = Number(credito.examen_final) || 0;
            const es = Number(credito.examen_suspension) || 0;

            const promedioParciales = this.promedioparciales(p1, p2, p3);
            const promedioFinal = this.promediototal(p1, p2, p3, ef, es);
            const estadoTexto = promedioFinal < 7 ? "REPROBADO" : "APROBADO";
            const equivalencia = promedioFinal < 7 ? 0 : 1;

            this.setState({
                modal: true,
                form: {
                    id: credito.id || "",
                    parcial1: p1,
                    parcial2: p2,
                    parcial3: p3,
                    examen_final: ef,
                    examen_suspension: es,
                    equivalencia: equivalencia,
                    asistencia: Number(credito.asistencia) || 0,
                    creditos_extra_id: credito.creditos_extra_id || "",
                    id_paralelo: credito.id_paralelo || "",
                    id_periodo_academico: credito.id_periodo_academico || ""
                },
                proma: promedioParciales,
                promf: promedioFinal,
                equivalencia: estadoTexto
            }, () => {
                // Si estás usando campos jQuery visibles (no controlados por React)
                $("#proma").val(promedioParciales);
                $("#promf").val(promedioFinal);
                $("#equivalencia").val(estadoTexto);
            });

        } else {
            this.setState({
                modal: true,
                form: {
                    id: "",
                    parcial1: 0,
                    parcial2: 0,
                    parcial3: 0,
                    examen_final: 0,
                    examen_suspension: 0,
                    equivalencia: false,
                    asistencia: 0,
                    creditos_extra_id: "",
                    id_paralelo: "",
                    id_periodo_academico: ""
                },
                proma: "",
                promf: "",
                equivalencia: ""
            }, () => {
                $("#proma").val("");
                $("#promf").val("");
                $("#equivalencia").val("");
            });
        }
    };
    ocultarModal = () => {
        this.setState({ modal: false });
    };

    handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        const parsedValue = ["creditos_extra_id", "id_paralelo"].includes(name)
            ? parseInt(value, 10)
            : value;
        this.setState({ form: { ...this.state.form, [name]: type === 'checkbox' ? checked : value, [name]: parsedValue } });
    };

    guardarCredito = () => {
        const { form, estudianteSeleccionado, periodoSeleccionado } = this.state;
        const data = { ...form, id_estudiante: estudianteSeleccionado, id_periodo_academico: periodoSeleccionado };
        const peticion = form.id ? axios.put(`${UrlActualizarCredito}/${form.id}${api_key}`, data) : axios.post(UrlInsertarCredito, data);
        peticion.then(() => {
            this.ocultarModal();
            this.obtenerCreditosEstudiante();
        });
    };

    promedioparciales = (p1, p2, p3) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        return (promp.toFixed(2))
    }

    promediosobre4 = (p10) => {
        var prom4 = (p10 * 4) / 10;
        return (prom4.toFixed(2))
    }

    promediototal = (p1, p2, p3, ef, es) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        var examfinal = (ef * 4) / 10;
        var promacumulado = promp + examfinal;
        //var promfinal = promacumulado >= 7 ? promacumulado : (promacumulado + es) / 2;
        var promfinal = 0.00;
        if (promacumulado >= 7) {
            promfinal = promacumulado;
        }
        else {

            if (((promacumulado >= 4) && (promacumulado < 7)) && (es == 0)) {
                promfinal = promacumulado;
            }
            else {
                if (((promacumulado >= 4) && (promacumulado < 7)) && (es > 0)) {

                    promfinal = (promacumulado + es) / 2;
                }
                else {
                    promfinal = promacumulado;
                }
            }
        }
        return (promfinal.toFixed(2))
    }

    actualizarValoresModal = async (e) => {
        const { name, type, checked, value } = e.target;

        await this.setState({
            [name]: type === 'checkbox' ? checked : value,
            form: {
                ...this.state.form,
                [name]: type === 'checkbox' ? checked : value
            }
        });

        // Cálculo de promedios
        const { parcial1, parcial2, parcial3, examen_final, examen_suspension } = this.state.form;
        const promparciales = this.promedioparciales(Number(parcial1), Number(parcial2), Number(parcial3));
        const promfinal = this.promediototal(Number(parcial1), Number(parcial2), Number(parcial3), Number(examen_final), Number(examen_suspension));

        // Determinar equivalencia como entero
        const equivalenciaInt = promfinal < 7 ? 0 : 1;
        const equivalenciaTexto = promfinal < 7 ? "REPROBADO" : "APROBADO";

        // Actualiza el form con equivalencia como entero
        this.setState({
            form: {
                ...this.state.form,
                equivalencia: equivalenciaInt
            },
            proma: promparciales,
            promf: promfinal,
            equivalencia: equivalenciaTexto // solo para mostrar en la interfaz
        });

        // Actualiza los campos visibles en el modal
        $("#proma").val(promparciales);
        $("#promf").val(promfinal);
        $("#equivalencia").val(equivalenciaTexto);
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 bg-white rounded">
                    <div className="back-istmas">
                        <b>Matrícula de de Estudiantes en Créditos Extra</b>
                    </div>

                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="fw-bold text-center mb-3 text-azul">Listado de Estudiantes</h6>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            placeholder="Buscar por cédula, nombre o apellido..."
                            value={this.state.busqueda}
                            onChange={this.filtrarEstudiantes}
                        />
                        <div className="table-responsive">
                            <table className="table table-hover table-sm-custom">
                                <thead>
                                    <tr className="text-azul">
                                        <th>Identificación</th>
                                        <th>Apellidos</th>
                                        <th>Nombres</th>
                                        <th>Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems.map((estu, index) => (
                                        <tr key={estu.id_estudiante} className="text-azul">
                                            <td>{estu.numero_identificacion_estudiante}</td>
                                            <td>{`${estu.primer_apellido_estudiante} ${estu.segundo_apellido_estudiante}`}</td>
                                            <td>{`${estu.primer_nombre_estudiante} ${estu.segundo_nombre_estudiante}`}</td>
                                            <td>
                                                <input
                                                    type="radio"
                                                    name="estudiante"
                                                    onChange={() => this.seleccionarEstudiante(estu.id_estudiante)}
                                                    checked={this.state.estudianteSeleccionado === estu.id_estudiante}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="d-flex justify-content-center mt-4">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div>

                            {this.state.estudianteSeleccionado && (
                                <div className="mt-2">
                                    <h6 className="text-azul">Seleccione un periodo:</h6>
                                    <select
                                        className="form-select form-select-sm w-auto"
                                        value={this.state.periodoSeleccionado}            // ← controlado
                                        onChange={this.seleccionarPeriodo}
                                    >
                                        <option value="">-- Seleccione --</option>
                                        {Array.isArray(this.state.periodos) && this.state.periodos.map(p => (
                                            <option
                                                key={p.id_periodo_academico}
                                                value={String(p.id_periodo_academico)}         // ← usa string por consistencia
                                            >
                                                {p.descripcion_periodo_academico}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {this.state.estudianteSeleccionado && this.state.periodoSeleccionado && (
                                this.state.creditosExtra.length > 0 ? (
                                    <div className="mt-4">
                                        <h6 className="text-azul">Créditos Extra</h6>
                                        <table className="table table-hover table-sm-custom">
                                            <thead>
                                                <tr className="text-azul">
                                                    <th>Asignatura</th>
                                                    <th>P1</th>
                                                    <th>P2</th>
                                                    <th>P3</th>
                                                    <th>Promedio Parcial/6</th>
                                                    <th>Final/4</th>
                                                    <th>Suspensión</th>
                                                    <th>Promedio Final/10</th>
                                                    <th>Estado</th>
                                                    <th>Asistencia</th>
                                                    <th>Opciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.creditosExtra.map(c => (
                                                    <tr key={c.id} className="text-azul">
                                                        <td>{c.credito_extra?.descripcion || 'Sin descripción'}</td>
                                                        <td>{c.parcial1}</td>
                                                        <td>{c.parcial2}</td>
                                                        <td>{c.parcial3}</td>
                                                        <td>{this.promedioparciales(Number(c.parcial1), Number(c.parcial2), Number(c.parcial3))}</td>
                                                        <td>{this.promediosobre4(c.examen_final)}</td>
                                                        <td>{c.examen_suspension}</td>
                                                        <td>{this.promediototal(Number(c.parcial1), Number(c.parcial2), Number(c.parcial3), Number(c.examen_final), Number(c.examen_suspension))}</td>
                                                        <td>{c.equivalencia === 1 ? "Aprobado" : "Reprobado"}</td>
                                                        <td>{c.asistencia}</td>
                                                        <td>
                                                            <button className="btn btn-sm btn-primary" onClick={() => this.mostrarModal(c)}>
                                                                <i className="fa fa-edit"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-warning mt-4">
                                        El estudiante no tiene créditos extra asignados en el periodo seleccionado.
                                    </div>
                                )
                            )}

                            {this.state.estudianteSeleccionado && this.state.periodoSeleccionado && (
                                <button className="btn btn-primary mt-3" onClick={() => this.mostrarModal()}>
                                    Agregar Crédito Extra
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.modal}>
                    <ModalHeader>Formulario Crédito Extra</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <label className="form-label">Crédito Extra</label>
                            <select className="form-select" id="creditos_extra_id" name="creditos_extra_id" value={this.state.form.creditos_extra_id} onChange={this.handleChange} aria-label="Default select example">
                                <option value="undefined">Seleccione el crédito:</option>
                                {this.state.creditos.map(consola => <option key={consola.id} value={consola.id} > {consola.descripcion}</option>)}
                            </select>
                            <label className="form-label">Paralelo</label>
                            <select className="form-select" id="id_paralelo" name="id_paralelo" value={this.state.form.id_paralelo} onChange={this.handleChange} aria-label="Default select example">
                                <option value="undefined">Seleccione el paralelo:</option>
                                {this.state.paralelos.map(consola => <option key={consola.id_paralelo} value={consola.id_paralelo} > {consola.nombre_paralelo}</option>)}
                            </select>
                            <label className="form-label">Parcial 1</label><br />
                            <input type="text" id="parcial1" name="parcial1" value={this.state.form.parcial1} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                            <label className="form-label">Parcial 2</label><br />
                            <input type="text" id="parcial2" name="parcial2" value={this.state.form.parcial2} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                            <label className="form-label">Parcial 3</label><br />
                            <input type="text" id="parcial3" name="parcial3" value={this.state.form.parcial3} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required />
                            <label className="form-label">Promedio Acumulado</label>
                            <input type="text" id="proma" name="proma" value={this.state.proma} className="form-control" placeholder="" autocomplete="off" required disabled />
                            <label>Examen Final</label>
                            <input type="number" name="examen_final" className="form-control" value={this.state.form.examen_final} onChange={this.actualizarValoresModal} />
                            <label>Examen Suspensión</label>
                            <input type="number" name="examen_suspension" className="form-control" onChange={this.actualizarValoresModal} />
                            <label className="form-label">Promedio Final</label><br />
                            <input type="text" id="promf" name="promf" value={this.state.promf} onChange={this.actualizarValoresModal} className="form-control" placeholder="" autocomplete="off" required disabled />
                            <label className="form-label">Estado</label><br />
                            <input type="text" id="equivalencia" name="equivalencia" value={this.state.equivalencia} className="form-control" placeholder="" autocomplete="off" required disabled />
                            <label>Asistencia</label>
                            <input type="number" name="asistencia" className="form-control" value={this.state.form.asistencia} onChange={this.handleChange} />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.guardarCredito}>Guardar</button>
                        <button className="btn btn-danger" onClick={this.ocultarModal}>Cancelar</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}